module.exports = __webpack_public_path__ + "assets/img/advantage2.9f7976c3.png";